import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { ApClassStaff } from "./ApClassStaff";
import type { ClassLocationDTOBase } from "./ClassLocationDTOBase";
import type { JpClassStaff } from "./JpClassStaff";
import type { TrackedBase } from "./TrackedBase";

export class ClassLocationStaff implements ClassLocationDTOBase, TrackedBase {
  constructor(public readonly locationId: number, public readonly locationName: string | null, public readonly active: string | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly apClasses: Array<ApClassStaff> | null, public readonly jpClasses: Array<JpClassStaff> | null) {
    this.cbiServiceContext = null;
    this.apClassesLoaded = this.apClasses != null;
    this.apClassesCached = this.apClasses;
    this.jpClassesLoaded = this.jpClasses != null;
    this.jpClassesCached = this.jpClasses;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private apClassesLoaded: boolean;
  private apClassesCached: Array<ApClassStaff> | null;
  private jpClassesLoaded: boolean;
  private jpClassesCached: Array<JpClassStaff> | null;
  async apClassesLazy(): Promise<Array<ApClassStaff>> {
    if (!this.apClassesLoaded) {
      this.apClassesCached = await this.cbiServiceContext!.classLocationService().getClassLocationStaffApClasses(this.locationId);
      this.apClassesLoaded = true;
    }
    return this.apClassesCached!;
  }
  async jpClassesLazy(): Promise<Array<JpClassStaff>> {
    if (!this.jpClassesLoaded) {
      this.jpClassesCached = await this.cbiServiceContext!.classLocationService().getClassLocationStaffJpClasses(this.locationId);
      this.jpClassesLoaded = true;
    }
    return this.jpClassesCached!;
  }
}
